import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';

@Component({
  selector: 'app-feature-store-no-access',
  templateUrl: './feature-store-no-access.component.html',
  styleUrls: ['./feature-store-no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeatureStoreNoAccessComponent {
  @Input() storeName = '';

  protected readonly iconColourEnum = IconColourEnum;
  protected readonly icons = IconsEnum;

  /**
   * Store label shown in the no-access copy.
   */
  protected get displayStoreName(): string {
    return this.storeName?.trim() || 'the selected store';
  }
}
